// extracted by mini-css-extract-plugin
export default {"studio-sticky-toolbar":"studioStickyToolbar_studio-sticky-toolbar__5onSm"};